import { ChevronDown } from "lucide-react";
import type { FC } from "react";

import { m } from "@recobra/i18n/messages";
import { Button } from "@recobra/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@recobra/ui/dropdown-menu";

/** How the assignee answered a checklist row, if at all. */
export type ChecklistItemAnswer = "pending" | "completed" | "dismissed";

/**
 * Concludes one checklist row by hand. A row that may also be concluded as a
 * nonexistent document opens a menu instead, leading with the plain completion;
 * a concluded row offers to revert its answer.
 */
export const ChecklistItemAction: FC<{
  answer: ChecklistItemAnswer;
  onComplete: () => void;
  /** Present when the row can be concluded as a nonexistent document. */
  onDismiss?: () => void;
  onRevert: () => void;
}> = ({ answer, onComplete, onDismiss, onRevert }) => {
  if (answer !== "pending")
    return (
      <Button type="button" variant="outline" size="xs" onClick={onRevert}>
        {m.task_requirement_undo()}
      </Button>
    );
  if (!onDismiss)
    return (
      <Button type="button" variant="outline" size="xs" onClick={onComplete}>
        {m.task_requirement_complete_item()}
      </Button>
    );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger render={<Button type="button" variant="outline" size="xs" />}>
        {m.task_requirement_complete_item()}
        <ChevronDown />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-auto">
        <DropdownMenuItem onClick={onComplete}>
          {m.task_requirement_complete_item()}
        </DropdownMenuItem>
        <DropdownMenuItem variant="destructive" onClick={onDismiss}>
          {m.task_requirement_dismiss()}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
